import Model from "@/lib/model/model";
import request from "@/lib/request/request";
import md5 from "js-md5";

//牛人星球相关

export class NRparam extends Model {
  connectCode = "";
  nrxqToken = "";
}

export default class NR extends Model {
  //检查状态
  static checkToken(param: NRparam) {
    return request.post("aiExam/nrxq/connect", param).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  //获取报告秘钥
  static getSid(param: any) {
    return request.post("aiExam/candidate/getSid", param).then(resp => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
}
export class CodeForm extends Model {
  phone = "";
}
export class LoginFrom extends Model {
  email = "";
  passwdMd5 = "";
  atsCompanyOutId = "";
  passwdMd5Chk = ""; //二次确认
  atsUserOutId = "";
  sign = ""; //找回密码用
}

export class Login extends Model {
  nrxqToken = "";
  nrxqLoginStatus = "";
  //发送找回邮件
  static forget(codeForm: any) {
    return request.post("aiExam/atsPublic/forgetPasswd", codeForm);
  }
  //设置新密码
  static sendNewPassword(codeForm: any) {
    const p = JSON.parse(JSON.stringify(codeForm));
    p.passwdMd5 = md5(p.passwdMd5 as string);
    delete p.passwdMd5Chk;

    return request.post("aiExam/atsPublic/savePasswd", p);
  }
  static getUserInfo(userId: any) {
    return request.post("aiExam/atsPublic/companyGet", userId);
  }
  static getUserInfoAfterLogin(atsUserToken: any) {
    return request.post("aiExam/atsHr/getUserCompany", atsUserToken);
  }

  static getCompanyInfo(companyId: any) {
    return request.post("aiExam/atsPublic/companyGet", companyId);
  }

  static login(form: LoginFrom) {
    const p = JSON.parse(JSON.stringify(form));
    p.passwdMd5 = md5(p.passwdMd5 as string);
    return request.post("aiExam/atsPublic/login", p).then(resp => {
      return resp;
    });
  }
}
//客户端
export class CV extends Model {
  //面试列表
  static list(p: any) {
    return request.post("aiExam/atsHr/cvList", p);
  }
  //解析简历
  static checkCV(p: any) {
    return request.post("aiExam/atsHr/resumeParse", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  //创建简历
  static saveCV(p: any) {
    return request.post("aiExam/atsHr/cvCreate", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
}
//牛星端
export class Ats extends Model {
  //客户公司 增删改查
  static getAtsCompanyList(p: any) {
    return request.post("aiExam/atsAdmin/companyList", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  static createAtsCompany(p: any) {
    return request
      .post("aiExam/atsAdmin/companyCreate", p)
      .then((resp: any) => {
        if (resp.data.code === 0) {
          return resp.data.data;
        }
      });
  }
  static updateAtsCompany(p: any) {
    return request
      .post("aiExam/atsAdmin/companyUpdate", p)
      .then((resp: any) => {
        if (resp.data.code === 0) {
          return resp.data.data;
        }
      });
  }
  static getAtsCompany(p: any) {
    return request.post("aiExam/atsAdmin/companyGet", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  //客户人员 增删改查
  static getAtsUserList(p: any) {
    return request.post("aiExam/atsAdmin/userList", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  static createAtsUser(p: any) {
    return request.post("aiExam/atsAdmin/userCreate", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  static updateAtsUser(p: any) {
    return request.post("aiExam/atsAdmin/userUpdate", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
  static getCandidateList(p: any) {
    return request.post("aiExam/atsAdmin/cvList", p).then((resp: any) => {
      if (resp.data.code === 0) {
        return resp.data.data;
      }
    });
  }
}

export class InfoForm extends Model {
  nrxqToken = "";
  name = "";
  companyName = "";
  connectCode = "";
}

export class Info extends Model {
  static set(from: InfoForm) {
    return request.post("aiExam/nrxq/saveContent", from).then(resp => {
      return resp.data.data;
    });
  }
}

export class AtsCompany extends Model {
  atsCompanyId = 0;
  atsCompanyOutId = "";
  name = "";
  isClose = false;

  static getCompanyList() {
    return request
      .post("/aiExam/atsAdmin/companyList", { pageSize: 100 })
      .then(resp => {
        if (resp.data.code === 0) {
          const array: AtsCompany[] = [];
          for (const item of resp.data.data.list) {
            array.push(new AtsCompany().assign(item));
          }
          return array;
        }
      });
  }
}

export class NRClientType {
  static NRClientTypeAdmin = "NRClientTypeAdmin";
  static NRClientTypeHR = "NRClientTypeHR";
  static NRClientTypeCandidate = "NRClientTypeCandidate";
}
